import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import { VFC } from 'react';

import { LimitedCollectionToken } from '@/apis/aniftyBackend/users/interface';
import routes from '@/config/routes';
import { convertFileNameToLowResolution } from '@/utils/convertFileName';

import styles from './UsersLimitedCollectionItem.module.scss';

type Props = {
  item: LimitedCollectionToken;
};

const UsersLimitedCollectionItem: VFC<Props> = ({ item }: Props) => {
  const { t } = useTranslation();

  return (
    <Link href={routes.limitedCollectionDetail(item.aniftyTokenID.toString())}>
      <a className={styles.limitedCollectionCard}>
        <video
          autoPlay
          muted
          loop
          preload="auto"
          playsInline
          className={styles.limitedCollectionImage}
        >
          <source
            src={convertFileNameToLowResolution(item.imageURL)}
            type="video/mp4"
          />
        </video>
        <h3 className={styles.limitedCollectionDescription}>
          {t(`limitedCollection:item${item.aniftyTokenID}.title`)}
        </h3>
      </a>
    </Link>
  );
};

export default UsersLimitedCollectionItem;
